/**
 * 格式化工具函数
 *
 * 提供各种数据格式化功能
 */

// 优化：预定义格式化单位常量，避免重复计算
const FORMAT_UNITS = [
  { threshold: 1000000, suffix: 'M', divider: 1000000 },
] as const;

/**
 * 格式化 Token 消耗显示
 * @param tokens Token 数量
 * @returns 格式化后的字符串（如：0.56M, 1.50M）
 */
export const formatTokens = (tokens: number): string => {
  // 所有 Token 都以 M 为单位显示
  return `${(tokens / 1000000).toFixed(2)}M`;
};